import React from "react";

const Paddy = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Paddy</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>CSR - 30 [Released in 15.11.2001]</strong>
              </td>
            </tr>
            <tr>
              <td>
                8-10 kgs per acre in ordinary soil and 12-16 in saline soil
              </td>
              <td>
                Nursery sowing upto 1st fortnight of June and transplantation
                upto end of July.
              </td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>Late maturity variety. 150-155 days.</td>
              <td>
                Suitable for irrigated area of Haryana, Punjab, west UP. It is a
                Vasmati variety. Plant height is around 155-160 cm but in sandy
                soil it is around 122-125 cm. Resistant to lodging. Medium
                resistance again blast and leaf curl diseases.
              </td>
              <td>
                12-24 quintals per acre in ordinary soil and 8-10 in saline
                soil.
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PUSA - 44 [Released in 02.09.1994]</strong>
              </td>
            </tr>
            <tr>
              <td>8-10 kgs per acre.</td>
              <td>
                Nursery sowing around 15th May to 10th June and transplantatio
                around 15th June to 7th July.
              </td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>140-145 days.</td>
              <td>
                Hard straw. Does not lodge. Long and clean grain. Resistant to
                most pests and diseases.
              </td>
              <td>22-24 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PR - 113 [Released in 26.03.2001]</strong>
              </td>
            </tr>
            <tr>
              <td>8-10 kgs per acre.</td>
              <td>
                Nursery sowing around 10th May to 20th May and transplantation
                around 15th June to 7th July.
              </td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>140-144 days.</td>
              <td>
                This variety is less resistant to root rot and bacterial blast.
              </td>
              <td>26-28 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HKR - 47 [Released in 05.11.2005]</strong>
              </td>
            </tr>
            <tr>
              <td>8-10 kgs per acre.</td>
              <td>Suitable for early as well as late sowing.</td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>135 days.</td>
              <td>
                Plant height is around 116 cm, i.e. it is a medium dwarf
                variety. Long, sleek, golden yellow grains. Leaves are straight
                and dark green in colour.
              </td>
              <td>32 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PR - 111 [Released in 04.05.1995]</strong>
              </td>
            </tr>
            <tr>
              <td>8-10 kgs per acre.</td>
              <td>Suitable for normal sowing.</td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>138 days.</td>
              <td>
                Good cooking quality, Long, sleek grain. Plant height is around
                97 cm. Straight leaves. Resistant to bacterial blight.
              </td>
              <td>27 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PUSA RH - 10 (Hybrid) [Released in 15.11.2001]</strong>
              </td>
            </tr>
            <tr>
              <td>3-4 kgs per acre.</td>
              <td>Medium early sowing variety</td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>120-125 days.</td>
              <td>
                Plant height around 90-110 cm. Resistant to lodging. Gives more
                yeild than Pusa Vasmati variety. Matures 15-20 days early. It
                has good aroma and cooking quality.
              </td>
              <td>17-18 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PR - 114 [Released in 26.03.2001]</strong>
              </td>
            </tr>
            <tr>
              <td>8-10 kgs per acre.</td>
              <td>
                Nursery sowing around 15th May to 10th June and transplantation
                around 15th June to 7th July.
              </td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>145 days.</td>
              <td>
                Plant height is around 102 cm. Medium dwarf variety. Extra
                ordinary long grain and good cooking quality.
              </td>
              <td>27.5 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PUSA - 1121 [Released in 05.11.2005]</strong>
              </td>
            </tr>
            <tr>
              <td>8-10 kgs per acre.</td>
              <td>
                Nursery sowing from 15th May to 10th June and transplantation
                from 15th June to 7th July.
              </td>
              <td>
                About 2'' water remained in the field and at the time of
                sprouting deep water should be in the field.
              </td>
              <td>135-140 days.</td>
              <td>
                Plant height is around 97.3 cm. Suitable for early and normal
                sowing. Gives good result in alkaline soil.
              </td>
              <td>22-26 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Paddy;
